export default __webpack_public_path__ + "static/media/1883.fdb625bc.png";